import React from 'react'
import { FilterResults } from './Filters'
import { FilterContextType, FilterDef } from './types'

export const getAppliedFilterCount = ({
  filterDef,
  filterResults,
}: {
  filterDef: FilterDef
  filterResults: string[]
}) => {
  filterResults = (filterResults ?? []).filter(
    (x) => x !== null && x !== undefined && x !== ''
  )

  return filterResults.length
}

export const getFiltersByFilterDef = ({
  filterDef,
  fields,
}: {
  filterDef: FilterDef
  fields: FilterResults
}): string[] => {
  const filterResults = getFilterResultsFromFields({
    fields,
    filterDefs: [filterDef],
  })
  let value

  if (filterDef.type === 'range') {
    value = [
      filterResults[filterDef.keyMin] ?? null,
      filterResults[filterDef.keyMax] ?? null,
    ]
  } else if (filterDef.type === 'date-range') {
    value = [
      filterResults[filterDef.keyDateStart] ?? null,
      filterResults[filterDef.keyDateEnd] ?? null,
    ]
  } else if (filterDef.type === 'toggle') {
    value = [filterResults[filterDef.key]]
  } else {
    value = filterResults[filterDef.key] ?? []
  }

  value = Array.isArray(value) ? value : [value]
  // istanbul ignore next
  return ((value ?? []) as string[]).filter(
    (v) => v !== null && v !== undefined
  )
}

export const FilterContext = React.createContext<FilterContextType>({
  filterDefs: [],
  resetField: () => {
    return {}
  },
  undoChanges: () => {},
  activeFilterValues: null,
})

export const getFilterResultsFromFields = ({
  fields,
  filterDefs,
}: {
  fields: FilterResults
  filterDefs: FilterDef[]
}): FilterResults => {
  let keys = Object.keys(fields)

  const newValues: {
    [x: string]: string[] | string
  } = {}

  filterDefs.forEach((filterDef) => {
    keys.forEach((key) => {
      const fieldValue = fields[key] as string

      if (filterDef.type === 'select-many') {
        const newArray = (newValues[filterDef.key] =
          newValues[filterDef.key] ?? []) as string[]

        if (key.split('-')[0] === filterDef.key && fieldValue) {
          newArray.push(fieldValue)
          newValues[filterDef.key] = newArray ?? []
        }

        newValues[filterDef.key] = newArray ?? []
      } else if (filterDef.type === 'range') {
        if (key === filterDef.keyMin) {
          newValues[filterDef.keyMin] = fields[filterDef.keyMin] as string
        }
        if (key === filterDef.keyMax) {
          newValues[filterDef.keyMax] = fields[filterDef.keyMax] as string
        }
      } else if (filterDef.type === 'date-range') {
        if (key === filterDef.keyDateStart) {
          newValues[filterDef.keyDateStart] = fields[
            filterDef.keyDateStart
          ] as string
        }
        if (key === filterDef.keyDateEnd) {
          newValues[filterDef.keyDateEnd] = fields[
            filterDef.keyDateEnd
          ] as string
        }
      } else {
        if (key === filterDef.key) {
          newValues[filterDef.key] = fieldValue
        }
      }
    })
  })

  Object.keys(newValues).forEach((key) => {
    if (
      newValues[key] === null ||
      newValues[key] === undefined ||
      (Array.isArray(newValues[key]) && newValues[key].length === 0) ||
      newValues[key] === ''
    ) {
      delete newValues[key]
    }
  })

  return newValues
}

export const removeEmptyKeys = function <T extends Record<string, any>>(
  obj: T
): T {
  return Object.keys(obj).reduce((acc, key) => {
    if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') {
      //@ts-ignore
      acc[key] = obj[key]
    }
    return acc
  }, {} as T)
}

export const getFilterDefKey = (filterDef: FilterDef) => {
  if (filterDef.type === 'date-range')
    return `${filterDef.keyDateStart}-${filterDef.keyDateEnd}`
  if (filterDef.type === 'range')
    return `${filterDef.keyMin}-${filterDef.keyMax}`
  return filterDef.key
}
